/* eslint-disable default-case */
import Enums from "./Enums";
import LoginService from "../services/LoginService";
import jwtDecode from 'jwt-decode';
// import * as AntDIcons from '@ant-design/icons';
import { FileImageOutlined, FilePdfOutlined, FilePptOutlined, FileWordOutlined, FileExcelOutlined, VideoCameraOutlined, FileOutlined } from '@ant-design/icons';
import {
   EMSIndividualReport,
   MTIndividualReport,
   SHSIndividualReport
} from '../pages/AssessmentPage/diagnostic-reports';
import { getReportFamily } from '../pages/AssessmentPage/diagnostic-reports/reportConfigResolver';
// import { getTwoToneColor, setTwoToneColor } from '@ant-design/icons';
import recursivelyLowercaseJSONKeys from 'recursive-lowercase-json';
import { Buffer } from 'buffer';
import { isFullscreen as isBrowserFullscreen } from './fullscreen';
import { getAssetSubdomain } from '../services/apiClient';
// import moment from 'moment';

const decodeJwt = () => {
   const jwt = localStorage.getItem('lms-jwt');

   if (jwt) {
      var decodedString = jwtDecode(jwt);
      return decodedString;
   }
   else {
      window.location.href = '/';
      return;
   }
}

const getCurrentUserInfo = (type) => {
   const jwt = localStorage.getItem('lms-jwt');

   if (jwt) {
      var decodedString = jwtDecode(jwt);
      if (type === Enums.UserInfo.role)
         return decodedString.role;
      if (type === Enums.UserInfo.username)
         return decodedString.username;
      if (type === Enums.UserInfo.id)
         return decodedString[Enums.UserInfo.id];
      if (type === Enums.UserInfo.fullname)
         return decodedString.unique_name;
      if (type === Enums.UserInfo.otherdata)
         return decodedString[Enums.UserInfo.otherdata];
   }
   else {
      window.location.href = '/';
      return;
   }
}

const checkFileImage = (type) => {
   switch (type) {
      case Enums.FileType.xls: case Enums.FileType.xlsx:
         return Enums.FileTypeImage.excel;
      case Enums.FileType.docx: case Enums.FileType.doc:
         return Enums.FileTypeImage.word;
      case Enums.FileType.pptx:
         return Enums.FileTypeImage.ppt;
      case Enums.FileType.ppsx:
         return Enums.FileTypeImage.ppsx;
      case Enums.FileType.pdf:
         return Enums.FileTypeImage.pdf;
      case Enums.FileType.jpeg: case Enums.FileType.png: case Enums.FileType.bmp:
         return Enums.FileTypeImage.img;
      case Enums.FileType.mp4:
         return Enums.FileTypeImage.mp4;
      default:
         return Enums.FileTypeImage.others;
   }
}

const verifyJwt = async () => {
   const jwt = localStorage.getItem('lms-jwt');

   if (jwt) {
      try {
         await LoginService.jwtValidation().catch((e) => {
            window.location.href = '/';
            return;
         })
      }
      catch {
         window.location.href = '/';
         return;
      }
   }
   else {
      window.location.href = '/';
      return;
   }
};

const convertKeysToLowerCase = (obj) => {
   // const isObject = o => Object.prototype.toString.apply(o) === '[object Object]'
   // const isArray = o => Object.prototype.toString.apply(o) === '[object Array]'

   // let transformedObj = isArray(obj) ? [] : {}

   // for (let key in obj) {
   //    // replace the following with any transform function
   //    const transformedKey = key.toLowerCase()

   //    if (isObject(obj[key]) || isArray(obj[key])) {
   //       transformedObj[transformedKey] = convertKeysToLowerCase(obj[key])
   //    } else {
   //       transformedObj[transformedKey] = obj[key]
   //    }
   // }
   var transformedObj = recursivelyLowercaseJSONKeys(obj)
   return transformedObj
};

function getFileIcon(fileName) {
   // setTwoToneColor("#1b5596");
   // getTwoToneColor();
   var retVal = null;

   const fileExtension = fileName.split(".").pop();

   switch (fileExtension.toUpperCase()) {
      case "PNG":
      case "JPG":
      case "JPEG":
         retVal = <FileImageOutlined />;
         break;
      case "PDF":
         retVal = <FilePdfOutlined />;
         break;
      case "PPT":
      case "PPTX":
         retVal = <FilePptOutlined />;
         break;
      case "DOC":
      case "DOCX":
         retVal = <FileWordOutlined />;
         break;
      case "XLS":
      case "XLSX":
         retVal = <FileExcelOutlined />;
         break;
      case "MP4":
      case "AVI":
         retVal = <VideoCameraOutlined />;
         break;
      default:
         retVal = <FileOutlined />;
         break;
   }

   return retVal;
}

function getPercentage(data, proficiency) {
   if (data) {
      if (proficiency === 'beginner')
         return (data.beginner / (data.beginner + data.basic + data.competent) * 100).toFixed(2);

      if (proficiency === 'basic')
         return (data.basic / (data.beginner + data.basic + data.competent) * 100).toFixed(2);

      if (proficiency === 'competent')
         return (data.competent / (data.beginner + data.basic + data.competent) * 100).toFixed(2);
   }
}

const displayDiagnosticReport = (template, assign_id, pre_assignment_id, subjectID, subject, studentID, assessment_id, school_year, diagnostic_type) => {
   if (subjectID === null) return;

   const reportFamily = getReportFamily(template, subjectID);
   let ReportComponent = SHSIndividualReport;

   if (reportFamily === 'ems') {
      ReportComponent = EMSIndividualReport;
   } else if (reportFamily === 'mt') {
      ReportComponent = MTIndividualReport;
   }

   if (ReportComponent) {
      return (
         <ReportComponent
            subject={subject}
            assignment_id={assign_id}
            student_id={studentID}
            template={template}
            subject_id={subjectID}
            assessment_id={assessment_id}
            school_year={school_year}
            pre_assignment_id={pre_assignment_id}
            diagnostic_type={diagnostic_type}
         />
      );
   }
}

function GetProficiency(percentage) {
   if (percentage >= 0 && percentage <= 59.49)
      return "BEGINNER";

   if (percentage >= 59.50 && percentage <= 79.49)
      return "PROFICIENT";

   if (percentage >= 79.50 && percentage <= 100)
      return "COMPETENT";
}

function GetCardBackground(subject, level) {
   var retVal = 'bg_default.png';

   if (level === 'formative_1')
      retVal = 'bg_l1_' + subject.toLowerCase().replace(/ /g, "_") + ".png";

   if (level === 'formative_2')
      retVal = 'bg_l2_' + subject.toLowerCase().replace(/ /g, "_") + ".png";

   if (level === 'formative_3')
      retVal = 'bg_l3_' + subject.toLowerCase().replace(/ /g, "_") + ".png";

   return retVal;
}

const getBase64 = (img, callback) => {
   const reader = new FileReader();
   reader.addEventListener('load', () => callback(reader.result));
   reader.readAsDataURL(img);
}

// const advancedImageCompress = async (file, options = {}) => {
//    const {
//       maxFileSize = 200000,
//       targetQuality = 0.85,
//       maxWidth = 1920,
//       maxHeight = 1920,
//       minQuality = 0.4,
//       useWebP = false,
//    } = options;

//    if (!(file instanceof File) || !`${file.type || ''}`.startsWith('image/')) {
//       return file;
//    }

//    const objectUrl = URL.createObjectURL(file);

//    try {
//       const image = await new Promise((resolve, reject) => {
//          const img = new Image();
//          img.onload = () => resolve(img);
//          img.onerror = reject;
//          img.src = objectUrl;
//       });

//       const canvas = document.createElement('canvas');
//       const context = canvas.getContext('2d');

//       if (!context) {
//          return file;
//       }

//       let width = image.width;
//       let height = image.height;
//       const widthRatio = maxWidth / width;
//       const heightRatio = maxHeight / height;
//       const resizeRatio = Math.min(1, widthRatio, heightRatio);

//       if (resizeRatio < 1) {
//          width = Math.max(1, Math.floor(width * resizeRatio));
//          height = Math.max(1, Math.floor(height * resizeRatio));
//       }

//       const outputType = ['image/jpeg', 'image/jpg', 'image/webp'].includes(file.type)
//          ? (file.type === 'image/jpg' ? 'image/jpeg' : file.type)
//          : 'image/jpeg';

//       let quality = Math.min(Math.max(targetQuality, minQuality), 1);
//       let attempts = 0;
//       let blob = null;

//       while (attempts < 12) {
//          canvas.width = width;
//          canvas.height = height;
//          context.clearRect(0, 0, width, height);
//          context.drawImage(image, 0, 0, width, height);

//          blob = await new Promise((resolve) => {
//             canvas.toBlob(resolve, outputType, quality);
//          });

//          if (!blob) {
//             return file;
//          }

//          if (blob.size <= maxFileSize) {
//             break;
//          }

//          if (quality > minQuality) {
//             quality = Math.max(minQuality, quality - 0.08);
//          } else {
//             width = Math.max(1, Math.floor(width * 0.9));
//             height = Math.max(1, Math.floor(height * 0.9));
//          }

//          attempts += 1;
//       }

//       if (!blob) {
//          return file;
//       }

//       const compressedExtension = outputType === 'image/webp' ? 'webp' : 'jpg';
//       const compressedName = `${file.name.replace(/\.[^/.]+$/, '')}.${compressedExtension}`;

//       return new File([blob], compressedName, {
//          type: outputType,
//          lastModified: Date.now(),
//       });
//    } catch (error) {
//       return file;
//    } finally {
//       URL.revokeObjectURL(objectUrl);
//    }
// }

const advancedImageCompress = async (file, options = {}) => {
   const {
      maxFileSize = 2000000, // 2MB
      targetQuality = 0.9,
      maxWidth = 1920,
      maxHeight = 1080,
      useWebP = true,
   } = options;

   const canvasToBlob = (canvas, type, quality) =>
      new Promise((resolve, reject) => {
         if (!canvas.toBlob) {
            reject(new Error("Canvas.toBlob is not supported"));
            return;
         }

         canvas.toBlob(
            (blob) => {
               if (blob) {
                  resolve(blob);
               } else {
                  reject(new Error("Failed to create blob"));
               }
            },
            type,
            quality
         );
      });

   return new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = async () => {
         try {
            let width = img.width;
            let height = img.height;

            // Resize to max dimensions
            if (width > maxWidth || height > maxHeight) {
               const ratio = Math.min(maxWidth / width, maxHeight / height);

               width = Math.round(width * ratio);
               height = Math.round(height * ratio);
            }

            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            if (!ctx) {
               throw new Error("Unable to create canvas context");
            }

            const outputType = useWebP ? "image/webp" : "image/jpeg";

            let currentWidth = width;
            let currentHeight = height;

            // Try multiple size reductions if necessary
            for (let resizeAttempt = 0; resizeAttempt < 5; resizeAttempt++) {
               canvas.width = currentWidth;
               canvas.height = currentHeight;

               ctx.clearRect(0, 0, currentWidth, currentHeight);

               ctx.imageSmoothingEnabled = true;
               ctx.imageSmoothingQuality = "high";

               // White background for JPEG
               if (outputType === "image/jpeg") {
                  ctx.fillStyle = "#ffffff";
                  ctx.fillRect(0, 0, currentWidth, currentHeight);
               }

               ctx.drawImage(
                  img,
                  0,
                  0,
                  currentWidth,
                  currentHeight
               );

               // Try decreasing quality levels
               for (
                  let quality = targetQuality;
                  quality >= 0.3;
                  quality -= 0.1
               ) {
                  const blob = await canvasToBlob(
                     canvas,
                     outputType,
                     Number(quality.toFixed(1))
                  );

                  if (blob.size <= maxFileSize) {
                     URL.revokeObjectURL(objectUrl);
                     resolve(blob);
                     return;
                  }
               }

               // Still too large? Reduce dimensions by 15%
               currentWidth = Math.round(currentWidth * 0.85);
               currentHeight = Math.round(currentHeight * 0.85);
            }

            // Final fallback: lowest acceptable quality
            const finalBlob = await canvasToBlob(
               canvas,
               outputType,
               0.3
            );

            URL.revokeObjectURL(objectUrl);
            resolve(finalBlob);
         } catch (error) {
            URL.revokeObjectURL(objectUrl);
            reject(error);
         }
      };

      img.onerror = () => {
         URL.revokeObjectURL(objectUrl);
         reject(new Error("Failed to load image"));
      };

      img.src = objectUrl;
   });
};

function convertLetterToNumber(letter) {
   if (letter !== null && letter !== undefined && letter !== '') {
      const charCode = letter.charCodeAt(0);
      if (charCode >= 65 && charCode <= 90) {
         return charCode - 64;
      } else {
         return '';
      }
   } else return '';
}

function generateSequenceNumbers(max_no) {
   const numbers = Array(max_no).fill().map((_, index) => index + 1);
   numbers.sort(() => Math.random() - 0.5);

   return numbers;
}

function shuffle(array) {
   for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
   }
   return array;
}

/**
 * Generates a shuffled sequence of numbers based on the structure of the input data.
 * For each contiguous group of non-section items, their indices (1-based) are shuffled and added to the result.
 * When a "section" is encountered or at the end of the data, the current group is flushed (shuffled), and the section index is added.
 * @param {Array} data - Array of objects, each with a 'type' property.
 * @returns {Array} numbers - Shuffled sequence of numbers with section indices in order.
 */
function generateSequenceNumbersV2(data) {
   const numbers = [];
   let tmpArray = [];

   for (let i = 0; i < data.length; i++) {
      const isSection = data[i].type.includes("section");
      const isLast = i === data.length - 1;

      if (isSection || isLast) {
         if (isLast && !isSection)
            tmpArray.push(i + 1);

         if (tmpArray.length > 0) {
            // Shuffle and add the accumulated group before the section/last item
            numbers.push(...shuffle(tmpArray));
            tmpArray = [];
         }
         // Always add the current section index
         if (isSection)
            numbers.push(i + 1);
      } else {
         // Accumulate non-section indices
         tmpArray.push(i + 1);
      }
   }

   return numbers;
}

function removeSpaces(str) {
   return str.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
}

function GetTypeLabel(assessment_type) {
   switch (assessment_type) {
      case 'formative_1':
         return 'Formative Level 1';
      case 'formative_2':
         return 'Formative Level 2';
      case 'formative_3':
         return 'Formative Level 3';
      case 'summative':
         return 'Summative';
      case 'study_plan_1':
         return 'Study Plan 1';
      case 'study_plan_2':
         return 'Study Plan 2';
   }
}

function dataUrlToFile(dataUrl, filename) {
   const arr = dataUrl.split(',');
   if (arr.length < 2) { return undefined; }
   const mimeArr = arr[0].match(/:(.*?);/);
   if (!mimeArr || mimeArr.length < 2) { return undefined; }
   const mime = mimeArr[1];
   const buff = Buffer.from(arr[1], 'base64');
   return new File([buff], filename, { type: mime });
}

function GetFormLocation(value) {
   switch (value) {
      case 0:
         return 'All';
      case 1:
         return 'Form 1';
      case 2:
         return 'Form 2';
      case 3:
         return 'Form 3';
      case 4:
         return 'Form 4';
   }
}

function standardDeviation(arr) {
   let mean = arr.reduce((acc, curr) => {
      return acc + curr
   }, 0) / arr.length;

   arr = arr.map((el) => {
      return (el - mean) ** 2
   })

   let total = arr.reduce((acc, curr) => acc + curr, 0);

   return Math.sqrt(total / arr.length);
}

const calculateStats = (data, scoreFields, mean, stdDev, ranges, isPost) => {
   // try {
   let total = 0;
   let min = 0;
   let max = 0;
   const scores = [];
   let beginner = 0;
   let basic = 0;
   let competent = 0;

   data.forEach(item => {
      const sum = scoreFields.reduce((acc, field) => acc + item[field], 0);
      min = Math.min(min, sum);
      max = Math.max(max, sum);
      total += sum;
      scores.push(sum);

      const zScore = (sum - mean) / stdDev;
      if (zScore > 1) competent++;
      else if (zScore >= -0.51) basic++;
      else if (zScore > -10) beginner++;
   });

   const average = parseFloat((total / data.length).toFixed(2));
   const proficiency = ranges.reduce((prev, [rangeMin, rangeMax, level]) => average >= rangeMin && average <= rangeMax ? level : prev, '');

   return {
      vn: data.length,
      prem: isPost ? -1 : average,
      postm: isPost ? average : -1,
      min,
      max,
      sd: standardDeviation(scores),
      proficiency,
      beginner,
      basic,
      competent
   };
   // } catch (error) {
   //    console.error('Error in calculateStats:', error.message);
   //    return {
   //       vn: 0,
   //       prem: -1,
   //       postm: -1,
   //       min: 0,
   //       max: 0,
   //       sd: 0,
   //       proficiency: '',
   //       beginner: 0,
   //       basic: 0,
   //       competent: 0
   //    };
   // }
};

// Single function to handle data extraction Diagnostic Summary Report for all subjects
const extractDataForDiagnosticSummaryReport = (diagnostic_type, pre_data, post_data, subjectConfigs) => {
   const { categories, totalRanges, setters } = subjectConfigs;
   const isPost = diagnostic_type === 'post';

   // Determine which data to use based on diagnostic type and availability
   const primaryData = isPost && post_data.length ? post_data : pre_data;

   // Calculate stats for each category
   const results = Object.entries(categories).reduce((acc, [key, { fields, mean, stdDev, ranges }]) => {
      // Compute stats for primary data (pre or post based on diagnostic_type)
      acc[key] = calculateStats(primaryData, fields, mean, stdDev, ranges, isPost);

      // If post data exists and we're not in post-only mode, calculate post mean
      if (post_data.length && !isPost) {
         var postm_ave = parseFloat((post_data.reduce((sum, item) => sum + fields.reduce((s, f) => s + item[f], 0), 0) / post_data.length).toFixed(2));
         acc[key].postm = isNaN(postm_ave) ? 0 : postm_ave;
      }
      else {
         var pre_ave = parseFloat((pre_data.reduce((sum, item) => sum + fields.reduce((s, f) => s + item[f], 0), 0) / pre_data.length).toFixed(2));
         acc[key].prem = isNaN(pre_ave) ? 0 : pre_ave;
      }


      return acc;
   }, {});

   // Aggregate totals across all categories
   const total = Object.values(results).reduce((acc, cat) => ({
      vn: isPost ? post_data.length : pre_data.length,
      prem: acc.prem + cat.prem,
      postm: acc.postm + cat.postm,
      min: acc.min + cat.min,
      max: acc.max + cat.max,
      sd: acc.sd + cat.sd,
      beginner: acc.beginner + cat.beginner,
      basic: acc.basic + cat.basic,
      competent: acc.competent + cat.competent
   }), { prem: 0, postm: 0, min: 0, max: 0, sd: 0, beginner: 0, basic: 0, competent: 0 });

   // Determine overall proficiency based on total score
   const totalScore = post_data.length ? total.postm : total.prem;
   total.proficiency = totalRanges.find(([min, max]) => totalScore >= min && totalScore <= max)?.[2] || '';

   // Update component state with calculated results
   Object.entries(setters).forEach(([key, setter]) => setter(key === 'total' ? total : results[key]));
};

const downloadFile = async (url, filename) => {
   // var name = moment().format("MM-DD-YYYY");

   // var re = new RegExp(' ', 'g');
   // Resolved per call: `Utils` is imported before init.js writes `lms-subdomain`, so reading the
   // tenant once at module load left every download pointed at `<S3>/null/...` (X-2).
   var finalUrl = `${process.env.REACT_APP_API_S3_URL}/${getAssetSubdomain()}/${url}`;
   var file_name = filename; //name.replace(re, '_');
   var pos = finalUrl.lastIndexOf('.');
   var ext = finalUrl.slice(pos);

   fetch(finalUrl)
      .then(response => {
         response.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = file_name + ext;
            a.click();
         });
      });
};

function hasBraineeResourcesAccess(sdbomain) {
   return ['content-creator-dbtijs', 'campuscloudacademy', 'dbti-makati', 'dev', 'localhost', 'ccph', 'bcs', 'gsa', 'hia', 'lamblights', 'mdochs', 'na', 'olmhra', 'pcs', 'pga', 'sha', 'snsr'].includes(sdbomain);
}

function determineOnlineOffline() {
   return window.location.hostname.match(/\.com/gi) ? "online" : "offline";
   // return "online";
}

function colorize() {
   var r = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
      g = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
      b = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2);
   return '#' + r + g + b;
}

function isFullScreen() {
   return isBrowserFullscreen();
}

const modules = {
   checkFileImage,
   verifyJwt,
   convertKeysToLowerCase,
   decodeJwt,
   getCurrentUserInfo,
   GetFileIcon: getFileIcon,
   getPercentage,
   displayDiagnosticReport,
   GetProficiency,
   GetCardBackground,
   getBase64,
   advancedImageCompress,
   convertLetterToNumber,
   generateSequenceNumbers,
   removeSpaces,
   GetTypeLabel,
   dataUrlToFile,
   generateSequenceNumbersV2,
   GetFormLocation,
   standardDeviation,
   calculateStats,
   extractDataForDiagnosticSummaryReport,
   downloadFile,
   hasBraineeResourcesAccess,
   determineOnlineOffline,
   colorize,
   isFullScreen
};

export default modules;
